import { createApp } from 'vue'
import App from './App.vue'
import { locale, setLocale, t } from './i18n/index.js'

// 导入全局样式
import './assets/styles/variables.css'
import './assets/styles/animations.css'
import './assets/styles/global.css'

setLocale(locale.value)
if (typeof document !== 'undefined') {
  document.title = t('meta.pageTitle')
}

// 创建Vue应用实例
const app = createApp(App)

// 挂载应用
app.mount('#app')